import { API_AUTHMEETING } from '../../../modules/API/constants_ts';
import { CONFERENCE_JOIN_IN_PROGRESS } from '../base/conference/actionTypes';
import { hideDialog } from '../base/dialog/actions';
import { JitsiConferenceEvents, JitsiSIPVideoGWStatus } from '../base/lib-jitsi-meet';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { beginAddSipId } from '../invite/actions.any';
import AddPeopleDialog from '../invite/components/add-people-dialog/web/AddPeopleDialog';
import { showErrorNotification, showNotification, showWarningNotification } from '../notifications/actions.any';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { addTmpSession, decreaseTotalSipInstance, increaseTotalSipInstance, saveData, saveOldNumberCTH, totalIn } from './actions';
import { ENABLE_SIP_CALL_IN, SIP_GW_AVAILABILITY_CHANGED, SIP_GW_INVITE_ROOMS, SIP_GW_LISTEN } from './actionTypes';
import logger from './logger';
/**
 * Middleware that captures conference video sip gw events and stores
 * the global sip gw availability in redux or show appropriate notification
 * for sip gw sessions.
 * Captures invitation actions that create sip gw sessions or display
 * appropriate error/warning notifications.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(({ getState, dispatch }) => next => action => {
    const result = next(action);
    const sipgwState = getState()['features/videosipgw'];
    switch (action.type) {
        case CONFERENCE_JOIN_IN_PROGRESS: {
            const { conference } = action;
            conference.on(JitsiConferenceEvents.VIDEO_SIP_GW_AVAILABILITY_CHANGED, (status) => dispatch(_availabilityChanged(status)));
            conference.on(JitsiConferenceEvents.VIDEO_SIP_GW_SESSION_STATE_CHANGED, (event) => {
                const toDispatch = _sessionStateChanged(event);
                // sessionStateChanged can decide there is nothing to dispatch
                if (toDispatch) {
                    dispatch(toDispatch);
                }
            });
            break;
        }
        case SIP_GW_LISTEN: {
            // _listen(action.username, action.password, action.domain, action.conference, dispatch);
            // const sipState = getState()['features/sip-callin'];
            // let isUp = sipState?.isUp;
            let isUp = 1;
            if (isUp !== 1 && isUp !== 0) {
                isUp = 1;
            }
            _verify(action.username, action.password, action.domain, action.conference, dispatch, isUp === 1, action.isShowPopup);
            break;
        }
        case ENABLE_SIP_CALL_IN: {
            let realNumberIn = action.numberIn;
            const oldNumberCTH = sipgwState.oldNumberCTH;
            _enableIn(action.token, action.sipId, action.conference, dispatch, realNumberIn, sipgwState.sipId || '', oldNumberCTH || 0);
            break;
        }
        case SIP_GW_INVITE_ROOMS:
            const username = sipgwState.sipId;
            _inviteRooms(action.rooms, action.conference, dispatch, username);
            break;
    }
    return result;
});
/**
 * Signals that sip gw availability had changed.
 *
 * @param {string} status - The new status of the service.
 * @returns {{
 *     type: SIP_GW_AVAILABILITY_CHANGED,
 *     status: string
 * }}
 * @private
 */
function _availabilityChanged(status) {
    return {
        type: SIP_GW_AVAILABILITY_CHANGED,
        status
    };
}
/**
 * Processes the action from the actionType {@code SIP_GW_INVITE_ROOMS} by
 * inviting rooms into the conference or showing an error message.
 *
 * @param {Array} rooms - The conference rooms to invite.
 * @param {Object} conference - The JitsiConference to invite the rooms to.
 * @param {Function} dispatch - The redux dispatch function for emitting state
 * changes (queuing error notifications).
 * @private
 * @returns {void}
 */
function _inviteRooms(rooms, conference, dispatch, username) {
    for (const room of rooms) {
        const { id: sipAddress, name: displayName } = room;
        if (sipAddress && displayName) {
            const newSession = conference
                .createVideoSIPGWSession(sipAddress, displayName, username);
            if (newSession instanceof Error) {
                const e = newSession;
                switch (e.message) {
                    case JitsiSIPVideoGWStatus.ERROR_NO_CONNECTION: {
                        dispatch(showErrorNotification({
                            descriptionKey: 'videoSIPGW.errorInvite',
                            titleKey: 'videoSIPGW.errorInviteTitle'
                        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                        return;
                    }
                    case JitsiSIPVideoGWStatus.ERROR_SESSION_EXISTS: {
                        dispatch(showWarningNotification({
                            titleKey: 'videoSIPGW.errorAlreadyInvited',
                            titleArguments: { displayName }
                        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                        return;
                    }
                }
                logger.error('Unknown error trying to create sip videogw session', e);
                return;
            }
            else {
                APP.store.dispatch(increaseTotalSipInstance(1));
            }
            newSession.start();
        }
        else {
            logger.error(`No display name or sip number for ${JSON.stringify(room)}`);
        }
    }
}
/**
 * Signals that a session we created has a change in its status.
 *
 * @param {string} event - The event describing the session state change.
 * @returns {Object|null} - A notification action.
 * @private
 */
function _sessionStateChanged(event) {
    switch (event.newState) {
        case JitsiSIPVideoGWStatus.STATE_PENDING: {
            return showNotification({
                titleKey: 'videoSIPGW.pending',
                titleArguments: {
                    displayName: event.displayName
                }
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT);
        }
        case JitsiSIPVideoGWStatus.STATE_FAILED: {
            // return showErrorNotification({
            //     titleKey: 'videoSIPGW.errorInviteFailedTitle',
            //     titleArguments: {
            //         displayName: event.displayName
            //     },
            //     descriptionKey: 'videoSIPGW.errorInviteFailed'
            // }, NOTIFICATION_TIMEOUT_TYPE.LONG);
            APP.store.dispatch(decreaseTotalSipInstance(1));
            return showErrorNotification({
                titleKey: 'videoSIPGW.sipError',
                titleArguments: {
                    displayName: event.displayName
                },
                // descriptionKey: 'videoSIPGW.errorInviteFailed'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG);
        }
        case JitsiSIPVideoGWStatus.STATE_OFF: {
            APP.store.dispatch(decreaseTotalSipInstance(1));
            if (event.failureReason === JitsiSIPVideoGWStatus.STATUS_BUSY) {
                return showErrorNotification({
                    descriptionKey: 'videoSIPGW.busy',
                    titleKey: 'videoSIPGW.busyTitle'
                }, NOTIFICATION_TIMEOUT_TYPE.LONG);
            }
            else if (event.failureReason) {
                logger.error(`Unknown sip videogw error ${event.newState} ${event.failureReason}`);
            }
        }
    }
    // nothing to show
    return null;
}
function _verify(inputUsername = null, inputPassword = null, inputDomain = null, conference, dispatch, isUp, isShowPopup = true) {
    const data = { username: inputUsername, password: inputPassword, domain: inputDomain, roomId: conference.room?.myroomjid.split("@")[0] };
    // const url = 'http://' + server_host + ':' + server_port + '/vmp/verify';
    const url = API_AUTHMEETING + 'verify';
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(data => {
        if (data.message === 'Wrong username or passcode' || data.message === 'Input cannot be empty') {
            dispatch(saveData('', '', conference, 'videoSIPGW.errorLoginWrongCredentials'));
            dispatch(showErrorNotification({
                descriptionKey: 'videoSIPGW.errorLoginWrongCredentials',
                titleKey: 'videoSIPGW.errorLoginTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
        else {
            let appData = "";
            let displayName = "";
            let sipId = "";
            let canSaveData = true;
            try {
                appData = data.token;
                displayName = data.sipId;
                sipId = inputUsername + '@' + inputDomain;
            }
            catch (err) {
                canSaveData = false;
            }
            if (canSaveData) {
                dispatch(saveData(appData, sipId, conference, ''));
                // dispatch(showNotification({
                //     titleKey: 'videoSIPGW.logIn',
                //     titleArguments: {
                //         sipId: sipId
                //     }
                // }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                if (isShowPopup) {
                    if (isUp) {
                        dispatch(beginAddSipId());
                    }
                    // else {
                    //     dispatch(beginGetSipContent());
                    // }
                }
            }
        }
    })
        .catch((error) => {
        dispatch(saveData('', '', conference, 'videoSIPGW.errorLoginFailedToFetch'));
        dispatch(showErrorNotification({
            descriptionKey: 'videoSIPGW.errorLoginFailedToFetch',
            titleKey: 'videoSIPGW.errorLoginTitle'
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    });
}
function _enableIn(token = null, sipId = null, conference, dispatch, numberIn, username, oldNumberCTH) {
    dispatch(totalIn(numberIn));
    let count = 0;
    try {
        let i = oldNumberCTH;
        while (count < numberIn) {
            const displayName = "CTH_" + i;
            const newSession = conference.createVideoSIPGWSession(token + "|" + i, displayName, username);
            // const newSession = conference.createVideoSIPGWSession(token , displayName);
            i = i + 1;
            if (newSession instanceof Error) {
                const e = newSession;
                switch (e.message) {
                    case JitsiSIPVideoGWStatus.ERROR_NO_CONNECTION: {
                        dispatch(showErrorNotification({
                            descriptionKey: 'videoSIPGW.errorLogin',
                            titleKey: 'videoSIPGW.errorLoginTitle'
                        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                        return;
                    }
                    case JitsiSIPVideoGWStatus.ERROR_SESSION_EXISTS: {
                        // break;
                        continue;
                    }
                    default: {
                        logger.error('Unknown error trying to create sip videogw session', e);
                        return;
                    }
                }
            }
            else {
                APP.store.dispatch(increaseTotalSipInstance(1));
            }
            count = count + 1;
            dispatch(addTmpSession(displayName, newSession));
            // dispatch(sendCommand(COMMANDS.SIP.COMMAND, 1, true))
            newSession.start(true, sipId);
        }
        if (i > oldNumberCTH) {
            dispatch(saveOldNumberCTH(i));
        }
    }
    catch (err) {
        dispatch(hideDialog(AddPeopleDialog));
    }
    dispatch(hideDialog(AddPeopleDialog));
    dispatch(showNotification({
        titleKey: 'videoSIPGW.newCallInMsg'
    }, NOTIFICATION_TIMEOUT_TYPE.LONG));
}
